export const brandStory = {
  title: '关于糖豆视频',
  subtitle: '汇聚精彩，分享快乐',
  founded: '成立于2020年',
  mission: '让每个人都能轻松享受高品质视频内容',
  description: `糖豆视频创立于2020年，是国内领先的免费视频聚合平台。我们汇聚了西瓜视频免费、小蓝视频、茄子视频、芒果视频等多个主流视频平台的优质资源，为用户提供一站式的在线观影体验。

糖豆视频的创始团队来自互联网和视频行业的资深从业者，我们深知用户对于高清流畅观影体验的渴望。因此，我们从创立之初就致力于打造一个资源丰富、更新及时、播放流畅的视频平台。

经过多年发展，糖豆视频已经积累了超过50,000部视频资源，涵盖电影、电视剧、综艺、动漫、纪录片、少儿等多个品类，日均更新超过200部内容，服务了超过800万在线用户。

我们始终坚持"免费、高清、流畅"的服务理念，不断优化技术架构和用户体验，力求让每一位用户都能在糖豆视频找到自己喜欢的视频内容，享受极致的观影体验。`,
  values: [
    { title: '资源丰富', description: '聚合多平台优质资源，涵盖电影、电视剧、综艺、动漫等全品类内容', icon: 'ri-database-2-line' },
    { title: '更新及时', description: '与各大平台同步更新，第一时间为用户带来最新最热的视频内容', icon: 'ri-flashlight-line' },
    { title: '高清流畅', description: '采用先进的视频传输技术，确保高清画质流畅播放，告别卡顿缓冲', icon: 'ri-4k-line' },
    { title: '用户体验', description: '简洁易用的界面设计，智能推荐算法，为用户打造个性化观影体验', icon: 'ri-user-heart-line' },
  ],
};

export const testimonials = [
  {
    id: 1,
    name: '张先生',
    avatar: 'ri-user-3-line',
    role: '资深影迷',
    content: '糖豆视频是我每天必用的观影平台！资源真的超级丰富，而且更新特别快。以前要装好几个APP才能看全想看的电影电视剧，现在一个糖豆视频就搞定了，太方便了！播放也很流畅，基本没遇到过卡顿的情况。强烈推荐给喜欢追剧看电影的朋友们！',
    rating: 5,
    date: '2026-07-15',
  },
  {
    id: 2,
    name: '李女士',
    avatar: 'ri-user-3-line',
    role: '全职妈妈',
    content: '作为两个孩子的妈妈，糖豆视频的少儿频道简直是我的救星！孩子们特别喜欢看动画片，糖豆视频上的少儿内容质量都很高，不用担心孩子看到不好的内容。而且完全免费，不用花钱充会员，对我们家庭来说真的很实惠。',
    rating: 5,
    date: '2026-07-10',
  },
  {
    id: 3,
    name: '王同学',
    avatar: 'ri-user-3-line',
    role: '大学生',
    content: '宿舍网速一般，但糖豆视频的加载速度真的让我惊喜！高清画质也能流畅播放，而且还不用缓冲。片源也很全，最新上映的电影很快就能在上面找到。课余时间就靠糖豆视频来放松了，已经推荐给全班同学了！',
    rating: 5,
    date: '2026-07-08',
  },
  {
    id: 4,
    name: '赵先生',
    avatar: 'ri-user-3-line',
    role: 'IT工程师',
    content: '作为一个技术从业者，我对视频平台的播放体验要求很高。糖豆视频的技术做得确实不错，视频加载快、清晰度高、而且界面设计简洁好用。聚合多平台资源这个点很贴心，不用在不同平台之间来回切换了。给技术团队点赞！',
    rating: 5,
    date: '2026-07-05',
  },
  {
    id: 5,
    name: '陈女士',
    avatar: 'ri-user-3-line',
    role: '退休教师',
    content: '退休之后有了很多空闲时间，糖豆视频成了我最好的陪伴。纪录片频道的内容特别精彩，《航拍中国》《舌尖上的中国》这些经典纪录片都有。字体大、操作简单，对我们老年人也很友好。非常感谢糖豆视频团队！',
    rating: 5,
    date: '2026-07-01',
  },
  {
    id: 6,
    name: '刘先生',
    avatar: 'ri-user-3-line',
    role: '综艺爱好者',
    content: '作为一名重度综艺爱好者，糖豆视频的综艺频道简直是天堂！《乘风破浪的姐姐》《奔跑吧兄弟》《中国新说唱》全都有，更新速度和官方平台同步。画质清晰流畅，周末窝在沙发上看一整天都不腻！',
    rating: 5,
    date: '2026-06-28',
  },
];

export const contactInfo = {
  email: 'contact@tangdoushipin.com',
  wechat: 'tangdoushipin',
  qq: '1234567890',
  address: '北京市朝阳区望京科技园',
  workingHours: '周一至周五 9:00 - 18:00',
};

export const faqList = [
  {
    question: '糖豆视频是免费的吗？',
    answer: '是的，糖豆视频完全免费！我们致力于为用户提供免费的在线视频观看服务，无需付费、无需会员，打开即可观看海量视频内容。',
  },
  {
    question: '糖豆视频的视频资源来自哪里？',
    answer: '糖豆视频聚合了西瓜视频免费、小蓝视频、茄子视频、芒果视频等多个主流视频平台的优质资源，为用户提供一站式的视频观看服务。',
  },
  {
    question: '为什么有些视频加载比较慢？',
    answer: '视频加载速度主要取决于您的网络环境和视频源服务器的状态。我们建议您检查网络连接，或尝试切换不同的视频源来获得更好的观看体验。',
  },
  {
    question: '糖豆视频支持哪些设备观看？',
    answer: '糖豆视频支持电脑、平板、手机等多种设备观看。您只需要使用浏览器访问我们的网站，无需下载任何软件或APP即可畅享观影体验。',
  },
  {
    question: '如何反馈问题或提出建议？',
    answer: '我们非常欢迎您的反馈！您可以通过页面底部的联系方式，发送邮件至 contact@tangdoushipin.com，或添加我们的微信客服，我们会尽快回复您。',
  },
];